export enum SourceSort {
  // Все данные сортируются по алфавиту, но 'LinkedIn' всегда будет первым
  'ALPHA_LINKED' = 'alphaLinked',
  'NAME' = 'name'
}

export interface Source {
  id: number;
  name: string;
  code: string;
  isSystem: boolean;
}

export interface SourceFetchParams {
  ids?: Array<number>;
  q?: string;
  sort?: SourceSort.ALPHA_LINKED;
  page?: number | string;
}
